import React, { FunctionComponent } from 'react';
import { compact } from 'lodash';
import * as Styled from './styled';

export interface PersonNameProps {
  /** Additional classes. */
  className?: string;

  /** Person data */
  person: {
    companyName?: string;
    forename?: string;
    surname?: string;
  };
}

export const PersonName: FunctionComponent<PersonNameProps> = (props) => {
  const { className, person, ...restProps } = props;

  const naturalPersonName = compact([person.forename, person.surname]).join(' ');

  const legalPersonName = person.companyName;

  const fullName =
    naturalPersonName && legalPersonName
      ? `${naturalPersonName} (${legalPersonName})`
      : naturalPersonName || legalPersonName;

  return (
    <Styled.PersonName lang="de" {...restProps}>
      {fullName}
    </Styled.PersonName>
  );
};

export default PersonName;
